import { RefObject } from 'react';
import { useIntersectionObserver as useIntersectionObserverHook } from 'usehooks-ts';

import { useIsHydrated } from './context/hydration.context';

export const useIntersectionObserver = (ref: RefObject<Element | null>, options?: IntersectionObserverInit) => {
  const isHydrated = useIsHydrated();
  const entry = useIntersectionObserverHook(ref as RefObject<Element>, options || {});

  return isHydrated ? entry : null;
};
